import jwtDecode from 'jwt-decode';
import Cookies from 'universal-cookie';

const adminRole = "utankjorfundarkerfi.admin"; 
const userAdminRole = "utankjorfundarkerfi.useradmin";

export const getIsAdmin = (context) => {
  const roles = context.user.get.details.role;

  // Roles from JWT only come back as an array if
  // there are more than 1 roles that are attached to the user
  if (Array.isArray(roles)) {
    return roles.some(x => x === adminRole);
  } else {
    return roles === adminRole
  } 
};

export const getIsUserAdmin = (context) => {
  const roles = context.user.get.details.role;

  // Roles from JWT only come back as an array if
  // there are more than 1 roles that are attached to the user
  if (Array.isArray(roles)) {
    return roles.some(x => x === userAdminRole);
  } else {
    return roles === userAdminRole
  } 
};

export const getIsTokenExpired = (accesstoken) => {
  const jwt = jwtDecode(accesstoken);

  if (jwt.exp !== undefined) {
    let currentTime = Date.now() / 1000; // JWT timestamp
    return jwt.exp < currentTime;
  }

  // JWT undefined
  return true;
};

export const logout = (context) => {
  const cookies = new Cookies();
  cookies.remove('accesstoken');
  context.isLoggedIn.set(false);
}
